import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  DataGridPro,
  GridActionsCellItem,
  GridColDef,
  GridEditInputCell,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridRowsProp,
  GridSlots,
  GridToolbarContainer,
} from "@mui/x-data-grid-pro";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
// import CancelIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";

import React, { useEffect, useState } from "react";
import { setArmsError } from "../../store/slices/studiesSlice";
import { useDispatch } from "react-redux";
interface EditToolbarProps {
  setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel
  ) => void;
  rows: [];
}

function EditToolbar(props: EditToolbarProps) {
  const { setRows, setRowModesModel } = props;

  const handleClick = () => {
    const id = crypto.randomUUID();
    setRows((oldRows) => [
      ...oldRows,
      { id, arm_title: "", arm_type: "", isNew: true },
    ]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "arm_title" },
    }));
  };

  return (
    <GridToolbarContainer>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="body1" gutterBottom>
            Arm Details <small color="text.secondary">(Optional)</small>
          </Typography>
        </Grid>
        <Grid item alignItems="flex-end" display="flex">
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            onClick={handleClick}
            className="mt3"
            id="add_arm_button"
          >
            Add Arm
          </Button>
        </Grid>
      </Grid>
    </GridToolbarContainer>
  );
}

export const AddArm = (props: any) => {
  const { armTypes, register, watch, setValue, studyData, isEdit } = props;

  const dispatch = useDispatch();

  const initialRows = isEdit
    ? studyData.study_arms?.map((item: any) => {
      return {
        ...item,
        id: crypto.randomUUID(),
        isNew: false,
      };
    })
    : [];

  const [rows, setRows] = React.useState<any[]>(initialRows);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );

  const handleDeleteClick = (id: GridRowId) => () => {
    setRows(rows.filter((row: any) => row.id !== id));
  };

  const processRowUpdate = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row: any) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const columns: GridColDef[] = [
    {
      field: "arm_title",
      headerName: "Arm Title",
      renderHeader: () => (
        <strong>
          Arm Title
          <span className="textRed">&nbsp;*</span>
        </strong>
      ),
      minWidth: 180,
      flex: 1,
      editable: true,
      renderEditCell: (params: any) => (
        <GridEditInputCell
          {...params}
          inputProps={{
            maxLength: 100,
            minLength: 0,
          }}
        />
      ),
      renderCell: (params: any) => (
        <TextField
          value={params.row.arm_title}
          className={params.row.arm_title.length <= 0 ? "errorBox" : undefined}
          id="arm-title"
        />
      ),
    },
    {
      field: "arm_type",
      renderHeader: () => (
        <strong>
          Arm Type
          <span className="textRed">&nbsp;*</span>
        </strong>
      ),
      minWidth: 160,
      flex: 1,
      type: "singleSelect",
      editable: true,
      valueOptions: armTypes?.map((item: any) => item.code_list_value),
      renderCell: (params) => (
        <Select
          value={params.row.arm_type}
          className={params.row.arm_title.length <= 0 ? "errorBox" : undefined}
          fullWidth
          id="arm_type"
        >
          {armTypes
            ?.map((item: any) => item.code_list_value)
            ?.map((item: any) => (
              <MenuItem value={item} key={item}>
                {item}
              </MenuItem>
            ))}
        </Select>
      ),
    },
    {
      field: "arm_description",
      headerName: "Description",
      minWidth: 200,
      flex: 1.5,
      editable: true,
      renderEditCell: (params: any) => (
        <GridEditInputCell
          {...params}
          inputProps={{
            maxLength: 100,
            minLength: 0,
          }}
        />
      ),
      renderCell: (params: any) => (
        <TextField value={params.row.arm_description} id="arm_description" />
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 90,
      cellClassName: "actions",
      getActions: (params) => {
        const { id } = params;
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            // <GridActionsCellItem
            //   key={`${id}-save`}
            //   icon={<SaveIcon />}
            //   label="Save"
            //   sx={{
            //     color: "primary.main",
            //   }}
            //   onClick={handleSaveClick(id)}
            //   disabled={!row.arm_title || !row.arm_type}
            // />,
            <GridActionsCellItem
              key={`${id}-delete`}
              icon={<DeleteIcon />}
              label="Cancel"
              onClick={handleDeleteClick(id)}
              color="primary"
            />,
          ];
        }

        return [
          // <GridActionsCellItem
          //   icon={<EditIcon />}
          //   key={`${id}-edit`}
          //   label="Edit"
          //   className="textPrimary"
          //   onClick={handleEditClick(id)}
          //   color="inherit"
          // />,
          <GridActionsCellItem
            key={`${id}-delete`}
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="primary"
          />,
        ];
      },
    },
  ];
  const [studyArms, setStudyArms] = useState<any>([]);

  useEffect(() => {
    const temp = rows.map((item: any) => {
      return {
        ...item,
        arm_type_code: "ARM_TYPE",
        arm_type_value_code: armTypes?.find(
          (type: any) => type.code_list_value == item.arm_type
        )?.code_list_value_code,
      };
    });
    temp.forEach((e) => {
      delete e.id;
      delete e.isNew;
    });
    setStudyArms(temp);
    if (
      rows?.find(
        (item: any) => (!item.arm_title || !item.arm_type) && !item.isNew
      )
    ) {
      dispatch(
        setArmsError(
          Object.keys(
            rows?.find((item: any) => !item.arm_title || !item.arm_type)
          ).length > 0
        )
      );
    } else {
      dispatch(setArmsError(false));
    }
  }, [rows, armTypes]);

  const watchStudyArms = watch("study_arms");

  useEffect(() => {
    setValue("study_arms", studyArms);
  }, [watchStudyArms, register, studyArms]);

  return (
    <>
      <Paper variant="outlined" className="p1">
        <Box
          sx={{
            minHeight: 200,
            width: "100%",
            "& .actions": {
              color: "text.secondary",
            },
            "& .textPrimary": {
              color: "text.primary",
            },
            borderBottom: "1px solid rgba(224, 224, 224)",
          }}
        >
          <DataGridPro
            autoHeight
            getRowHeight={() => "auto"}
            rows={rows}
            columns={columns}
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            processRowUpdate={processRowUpdate}
            slots={{
              toolbar: EditToolbar as GridSlots["toolbar"],
            }}
            slotProps={{
              toolbar: { setRows, setRowModesModel, rows },
            }}
            hideFooter
            hideFooterRowCount
            hideFooterSelectedRowCount
            hideFooterPagination
          />
          <input
            type="hidden"
            value={studyArms}
            {...register("study_arms", { value: studyArms })}
          // error={studyArms}
          />
        </Box>
      </Paper>
      {rows?.find(
        (item: any) => (!item.arm_title || !item.arm_type) && !item.isNew
      ) &&
        Object.keys(
          rows?.find(
            (item: any) => (!item.arm_title || !item.arm_type) && !item.isNew
          )
        ).length > 0 && (
          <small className="textRed">Missing Mandatory Fields</small>
        )}
    </>
  );
};
